<template>
    <v-app id="app" class="scroll-y">
      <!-- <transition name="fade" mode="out-in" appear> -->
      <router-view/>
      <!-- </transition> -->
      <v-fab-transition>
       
                <v-btn
                  v-scroll="onScroll"
                  v-show="fab"
                  fab
                  dark
                  fixed
                  bottom
                  right
                  color="teal"
                  @click="toTop"
                >
                  <v-icon>keyboard_arrow_up</v-icon>
                </v-btn>
              <!-- <div class="my-2">
                <v-btn color="amber lighten-1" @click.native="openSOM()" fab fixed bottom right>
                  <v-icon dark large>mdi-bullhorn</v-icon>
                </v-btn>
              </div> -->
      </v-fab-transition>
      <PluginSOM
        :dialog="PluginSOMVisable.show"
        @close="PluginSOMVisable.show = false"
        @update="update()"
      ></PluginSOM>
    </v-app>
</template>

<script>
const PluginSOM = () => import("@/components/landingpages/dialogs/landing-page-som")
import { mapState } from "vuex";
import axios from "axios";
import { format, addDays } from "date-fns";
export default {
  name: "App",
  components: { PluginSOM },
  data: function() {
    return {
      PluginSOMVisable: { show: false },
      fab: false
    };
  },
  methods: {
    openSOM() {
      this.PluginSOMVisable.show = true;
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    }
  },
  created(){
    this.$i18n.locale = this.language
  },
  computed:{
   language:{
      get(){
        if(localStorage.getItem('lang')){
          this.$i18n.locale = localStorage.getItem('lang')
          return localStorage.getItem('lang')
        }
        else{
          localStorage.setItem('lang','th')
          this.$i18n.locale = localStorage.getItem('lang')
          return localStorage.getItem('lang')
        }
      }
   }
  }
};
</script>

<style>
#app {
  font-family: "Sarabun", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* background-color: white; */
}

/* #bg_Portal {
  background: #ffffff;
} */

.fade-enter-active {
  transition: opacity 0.5s ease;
  transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.fade-leave-active {
  transition: opacity 0.5s ease;
  transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.swal-footer {
  text-align: center;
}

.swal-modal {
  font-family: "Sarabun", sans-serif;
}
.v-input .v-label {
  font-size: 13px;
}
.v-input >>> .v-input--selection-controls {
   font-size: 5px;
}
.v-input input {
  font-size: 13px;
}
</style>




// WEBPACK FOOTER //
// src/App.vue